'use client'
import React from 'react';
import { ChevronRight } from 'lucide-react'
import { useLocation, Link } from "react-router-dom";
import { usePageSave } from '../../contexts/PageSaveContext';

export default function BreadCrumb() {
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);
  const { isPageSaved } = usePageSave();
  
  // Required pages for return preparation status calculation
  const requiredPages = [
    { key: 'profile', label: 'Profile' },
    { key: 'salary', label: 'Salary' },
    { key: 'filing-section', label: 'Filing Section' }
  ];
  
  // Calculate completion percentage
  const completedPages = requiredPages.filter(page => isPageSaved(page.key)).length;
  const completionPercentage = Math.round((completedPages / requiredPages.length) * 100);

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-5">
      
      {/* Breadcrumbs */}
     <div>
       <div className="flex items-center gap-2 text-sm text-gray-500 flex-wrap">
        <Link to="/" className="text-gray-600 hover:underline">
          Home
        </Link>
        <div>
          <div className='flex items-center gap-2 text-sm text-gray-500 flex-wrap'>
          {pathParts.map((part, index) => {
          const pathUrl = `/${pathParts.slice(0, index + 1).join("/")}`;
          const isLast = index === pathParts.length - 1;
          return (
            <React.Fragment key={index}>
              <ChevronRight className="w-4 h-4" />
              {isLast ? (
                <span className="text-gray-600">{decodeURIComponent(part)}</span>
              ) : (
                <Link to={pathUrl} className="hover:underline">
                  {decodeURIComponent(part)}
                </Link>
              )}
              
            </React.Fragment>
          );
        })}
        </div>
        
        </div>
       
      </div>
       <h2 className="text-2xl font-semibold text-gray-800 capitalize">
          {(decodeURIComponent(pathParts[pathParts.length - 1] || "Home")).replace('-', ' ')}
        </h2>
     </div>

      {/* Title + Progress */}
      <div className="flex items-center gap-4 justify-between">
        <h2 className="text-2xl font-semibold text-gray-800 capitalize">
         {/* Form Completed */}
        </h2>

        {/* Progress Circle */}
        <div className="relative w-12 h-12">
          <svg className="w-full h-full" viewBox="0 0 36 36">
            <path
              className="text-gray-200"
              strokeWidth="3"
              stroke="currentColor"
              fill="none"
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="text-green-500"
              strokeWidth="3"
              strokeDasharray={`${completionPercentage}, 100`}
              strokeLinecap="round"
              stroke="currentColor"
              fill="none"
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center text-green-600 text-sm font-bold">
            {completionPercentage}%
          </div>
        </div>
      </div>
    </div>
  );
}
